import { ActionReducer, Action } from '@ngrx/store';
import { UpsellBooking } from '../models/upsell-booking.interface';

export const UPSELL_BOOKING_STATUS = 'UPSELL_BOOKING_STATUS';
export const UPDATE_ABC_TIMESLOT_STATUS = 'UPDATE_ABC_TIMESLOT_STATUS';
export const UPDATE_CCD_TIMESLOT_STATUS = 'UPDATE_CCD_TIMESLOT_STATUS';
export const REFRESH_UPSELL_BOOKING = 'REFRESH_UPSELL_BOOKING';
export const RESET_UPSELL_BOOKING = 'RESET_UPSELL_BOOKING';


export interface ActionWithPayloadInterface extends Action {
  payload: any;
}


const initialState: UpsellBooking = {
  showUpsellScreen: false,
  upsellConverted: false,
  abcTimeslotsAvailable: true,
  ccdTimeslotsAvailable: true,
  currentBooking: '',
  upsellBooking: ''
}

export function upsellBookingReducer(state = initialState, action: ActionWithPayloadInterface) {
  switch (action.type) {
    case UPSELL_BOOKING_STATUS:
      return handleUpsellBooking(state, action.payload);

    case UPDATE_ABC_TIMESLOT_STATUS:
      return Object.assign({}, state, { abcTimeslotsAvailable: action.payload });

    case UPDATE_CCD_TIMESLOT_STATUS:
      return Object.assign({}, state, { ccdTimeslotsAvailable: action.payload });

    case REFRESH_UPSELL_BOOKING:
      return Object.assign({}, action.payload);
    
    case RESET_UPSELL_BOOKING:
      return Object.assign({}, initialState);

    default:
      return state;
  }
}

function handleUpsellBooking(state, data) {
  return Object.assign({}, state, {
    showUpsellScreen: data.showUpsellScreen,
    currentBooking: data.currentBooking,
    upsellBooking: data.upsellBooking,
    upsellConverted: data.upsellConverted
  });
}
